<template>
  <div class="m-list">
    <template v-for="(listItem, listItemIndex) in list">
      <template v-if="!listItem.subList">
        <v-list-item
          :title="listItem.title"
          :route="listItem.route"
          :key="listItemIndex"
          :exact="listItem.exact"
          :listIcon="listItem.listItemIcon"
          :inverted="listItem.inverted">
        </v-list-item>
      </template>
      <template v-else>
        <v-list-item
          :title="listItem.title"
          :action="toggleSubList"
          :key="listItemIndex"
          :icon="subNavStates[listItemIndex].icon"
          :id="listItemIndex"
          :active="subNavStates[listItemIndex].active"
          class="m-list__sub-list__item">
        </v-list-item>
        <div
          class="m-list__sub-list"
          v-show="subNavStates[listItemIndex].active"
          :key="listItemIndex">
          <template v-for="(subListItem, index) in listItem.subList">
            <v-list-item
              :key="index"
              :title="subListItem.title"
              :route="subListItem.route">
            </v-list-item>
          </template>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { VListItem } from '../atoms';

export default {
  name: 'v-list',
  props: {
    list: {
      type: Array,
      required: true,
    },
    icons: {
      type: Array,
      required: false,
    },
  },
  components: {
    VListItem,
  },
  data() {
    return {
      subNavStates: {},
    };
  },
  created() {
    this.list.forEach((item, index) => {
      if (item.subList) {
        this.$set(this.subNavStates, index, {
          active: false,
          id: index,
          icon: this.icons[0],
        });
      }
    });
  },
  methods: {
    toggleSubList($event) {
      const id = $event.target.getAttribute('data-id');
      this.subNavStates[id].active = !this.subNavStates[id].active;
      this.subNavStates[id].icon = !this.subNavStates[id].active ? this.icons[0] : this.icons[1];
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/component-utils';

  $parent: '.m-list';

  #{$parent} {

  }
</style>
